import React from "react";
import { Modal, Backdrop, Fade, Box, CircularProgress } from "@mui/material";
import { styled } from "@mui/system";

const StyledOverlayContent = styled(Box)({
  "&.MuiBox-root": {
    boxSizing: "content-box",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "200px",
    height: "176px",
    backgroundColor: "#fff",
    padding: 40,
    borderRadius: "20px",
    "&:focus-visible": {
      outline: "none !important"
    }
  },
  "& .bottom": {
    "&.MuiCircularProgress-root": {
      color: "rgba(147, 147, 147, 0.1)",
      position: "absolute",
      left: "40%",
      top: "25%"
    }
  },
  "& .top": {
    "&.MuiCircularProgress-root": {
      color: "#848484",
      animationDuration: "550ms",
      position: "absolute",
      left: "40%",
      top: "25%"
    }
  },
  "& .circle": {
    "&.MuiCircularProgress-circle": {
      strokeLinecap: "round"
    }
  },
  "& .text": {
    marginTop: "120px",
    fontWeight: 400,
    fontSize: 14,
    lineHeight: "20px",
    color: "#757575",
    textAlign: "center"
  }
});

export const OverlayLoader = ({ open, text }) => {
  return (
    <Modal
      open={open}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
      disableRestoreFocus
      data-testid="overlay-loader"
    >
      <Fade in={open}>
        <StyledOverlayContent>
          <CircularProgress
            variant="determinate"
            className="bottom"
            thickness={4}
            value={100}
            size={60}
          />
          <CircularProgress
            variant="indeterminate"
            disableShrink
            className="top"
            classes={{
              circle: "circle"
            }}
            thickness={4}
            size={60}
          />
          <div className="text">{text}</div>
        </StyledOverlayContent>
      </Fade>
    </Modal>
  );
};
